import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
let serverUrl = getSecret('SERVER_URL');

export const getters = {
    getTypeActorFields() {
        return {
            model: 'type_actor',
            label: 'Types Actor',
            fields: [
                { key: 'name', label: 'Name', type: 'text', sortable: true, required: true },
                { key: 'id_license', label: 'id_license', type: 'number', sortable: true, required: true },
                { key: 'status', label: 'status', type: 'boolean', sortable: true, required: true },
            ]
        }
    },
}

export const actions = {
    async fetchProducts(context, query = '') {
        return axios
            .get(`${serverUrl}/api/v1/masters/products/${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async fetchOptionsProducts(context, query = '') {
        return axios
            .options(`${serverUrl}/api/v1/masters/products/${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async createProducts(context, payload) {
        return axios
            .post(`${serverUrl}/api/v1/masters/products/`, payload)
            .then((response) => {
                return response.data;
            })
    },

    async updateProducts(context, payload) {
        return axios
            .put(`${serverUrl}/api/v1/masters/products/${payload.id}/`, payload)
            .then((response) => {
                return response.data;
            })
    },

    async deleteProducts(context, id) {
        return axios
            .delete(`${serverUrl}/api/v1/masters/products/${id}/`)
            .then((response) => {
                return response.data;
            })
    },

    async fetchProductsPrice(context, query = '') {
        return axios
            .get(`${serverUrl}/api/v1/masters/products_price/${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async fetchOptionsProductsPrice(context, query = '') {
        return axios
            .options(`${serverUrl}/api/v1/masters/products_price/${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async createProductsPrice(context, payload) {
        return axios
            .post(`${serverUrl}/api/v1/masters/products_price/`, payload)
            .then((response) => {
                return response.data;
            })
    },

    async updateProductsPrice(context, payload) {
        return axios
            .put(`${serverUrl}/api/v1/masters/products_price/${payload.id}/`, payload)
            .then((response) => {
                return response.data;
            })
    },

    async deleteProductsPrice(context, id) {
        return axios
            .delete(`${serverUrl}/api/v1/masters/products_price/${id}/`)
            .then((response) => {
                return response.data;
            })
    },
}